import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(value: any[], filterMethod): any[] {
    return value.filter((e) => filterMethod(e));
  }
}
